import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title,
  description,
  lang,
  schema,
  path = ''
}) {
  const baseUrl = 'https://barberadelvalles.fit';
  const canonicalUrl = `${baseUrl}${path}`;
  const esUrl = canonicalUrl;
  const enUrl = `${canonicalUrl}${path.includes('?') ? '&' : '?'}lang=en`;
  const schemaJson = schema ? JSON.stringify(schema) : null;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta name="geo.region" content="ES-CT" />
      <meta name="geo.placename" content="Barberà del Vallès" />
      <meta name="geo.position" content="41.5167;2.1167" />
      <meta name="ICBM" content="41.5167,2.1167" />

      <link rel="alternate" hreflang="es" href={esUrl} />
      <link rel="alternate" hreflang="en" href={enUrl} />
      <link rel="alternate" hreflang="x-default" href={esUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {schemaJson && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: schemaJson }}
        />
      )}
    </Helmet>
  );
}